import {connect} from "react-redux";
import {State} from "../reducers";
import LoadingSpinner from "../components/LoadingSpinner";
import {createLoadingUnselector} from "../utils/selectors";
import {DELETE_SESSION_BASE, POST_OTP_BASE, POST_SESSION_BASE} from "../actions/login";
import {IMPORT_FILE_BASE, UPDATE_PRODUCT_BASE} from "../actions/products";


const loadingSelector = createLoadingUnselector([
  POST_SESSION_BASE,
  DELETE_SESSION_BASE,
  POST_OTP_BASE,
  UPDATE_PRODUCT_BASE,
  IMPORT_FILE_BASE
]);
const mapStateToProps = (state: State) => ({
  loading: loadingSelector(state)
});

export default connect(mapStateToProps)(LoadingSpinner);
